import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';

export interface FolderState {
  loadingPagination: {[key: string]: boolean};
  isEditingFolder: {[key: string]: boolean};
  isEditingFolderDraft: {[key: string]: string};
  isMenuOpen: {[key: string]: boolean};
}

const initialState: FolderState = {
  loadingPagination: {},
  isEditingFolder: {},
  isEditingFolderDraft: {},
  isMenuOpen: {},
};

export const folderSlice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    setPaginationState: (
      state,
      action: PayloadAction<{[key: string]: boolean}>,
    ) => {
      const key = Object.keys(action.payload)[0];
      state.loadingPagination[key] = action.payload[key];
    },
    setEditingFolder: (
      state,
      action: PayloadAction<{[key: string]: boolean}>,
    ) => {
      const key = Object.keys(action.payload)[0];
      state.isEditingFolder[key] = action.payload[key];
    },
    setEditingFolderName: (
      state,
      action: PayloadAction<{[key: string]: string}>,
    ) => {
      const key = Object.keys(action.payload)[0];
      state.isEditingFolderDraft[key] = action.payload[key];
    },
    setIsMenuOpen: (
      state,
      action: PayloadAction<{[key: string]: boolean}>,
    ) => {
      const key = Object.keys(action.payload)[0];
      state.isMenuOpen[key] = action.payload[key];
    },
  },
});

export const {
  setPaginationState,
  setEditingFolder,
  setEditingFolderName,
} = folderSlice.actions;

export default folderSlice.reducer;
